/**
 * CheTuo Web — Shop API functions.
 * Reuses /api/shop-mobile/shops/* endpoints.
 */

import { apiClient, shopMobilePath } from './client';

export interface ShopView {
  id: string;
  name: string;
  ownerUserId: string;
  trialStartedAt: string;
  activatedAt: string | null;
  expiredReadonlyUntil: string | null;
  status: string;
  trialState: 'trial' | 'readonly' | 'expired' | 'active';
  trialEndsAt: string;
  readonlyEndsAt: string | null;
  remainingTrialDays: number;
  createdAt: string;
  updatedAt: string;
}

export function listMyShops(): Promise<ShopView[]> {
  return apiClient.get<ShopView[]>(shopMobilePath('/shops'));
}

export function getMyShop(): Promise<ShopView> {
  return apiClient.get<ShopView>(shopMobilePath('/shops/me'));
}

export function updateShopName(name: string) {
  return apiClient.patch(shopMobilePath('/shop-manage'), { name });
}
